import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "current", "chosen"]

  pick() {
    this.inputTarget.click()
  }

  select() {
    const file = this.inputTarget.files[0]

    this.currentTarget.classList.toggle("hidden", Boolean(file))
    this.chosenTarget.textContent = file ? file.name : ""
  }
}
